import { createTheme } from "@mui/material/styles";

export const BRAND_BLUE = "#0058a5";
export const BRAND_BLUE_LIGHT = "#1a7fd4";
export const BRAND_BLUE_DARK = "#003d73";

// Light theme used across the auth flow (login/register/forgot-reset password).
export const AUTH_BG = "#ffffff";
export const AUTH_CARD_BORDER = "#e2e8f0";
export const AUTH_INPUT_BG = "#ffffff";
export const AUTH_INPUT_BORDER = "#d1d5db";
export const AUTH_TEXT_PRIMARY = "#1a1a1a";
export const AUTH_TEXT_SECONDARY = "#6b7280";
export const AUTH_TEXT_MUTED = "#9ca3af";
export const AUTH_ERROR = "#DC2626";
export const AUTH_SUCCESS = "#16A34A";

const appTheme = createTheme({
  palette: {
    primary: {
      main: BRAND_BLUE,
    },
  },
  typography: {
    fontFamily:
      '"Roboto Condensed", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 13,
    htmlFontSize: 14,
    h1: { fontSize: "1.75rem" },
    h2: { fontSize: "1.5rem" },
    h3: { fontSize: "1.25rem" },
    h4: { fontSize: "1.125rem" },
    h5: { fontSize: "1rem" },
    h6: { fontSize: "0.875rem" },
    body1: { fontSize: "0.875rem" },
    body2: { fontSize: "0.8125rem" },
    caption: { fontSize: "0.75rem" },
    button: { fontSize: "0.8125rem", textTransform: "none" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          "&.Mui-disabled": {
            color: "#A3A3A3",
            backgroundColor: "#F5F5F5",
            opacity: 1,
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          fontSize: "0.8125rem",
          "& .MuiDataGrid-checkboxInput": {
            color: "#D0D5DD",
            "&.Mui-checked, &.MuiCheckbox-indeterminate": {
              color: "#282828",
            },
          },
        },
        columnHeader: { fontSize: "0.8125rem" },
        columnHeaderTitle: {
          fontWeight: 600,
          fontSize: "0.6875rem",
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          color: "#6b7280",
        },
        cell: { fontSize: "0.8125rem" },
        footerContainer: {
          borderTop: "1px solid #e5e7eb",
          minHeight: 52,
          paddingLeft: 8,
          paddingRight: 8,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: { color: "#6b7280", fontSize: "0.8125rem" },
        selectLabel: { fontSize: "0.8125rem", color: "#6b7280" },
        displayedRows: { fontSize: "0.8125rem", color: "#374151" },
        select: { fontSize: "0.8125rem" },
        actions: {
          "& .MuiIconButton-root": {
            borderRadius: 8,
            "&:hover": { backgroundColor: "#f5f5f5" },
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          boxShadow:
            "0px 4px 12px rgba(16,24,40,0.10), 0px 2px 4px rgba(16,24,40,0.06)",
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow:
            "0px 4px 12px rgba(16,24,40,0.10), 0px 2px 4px rgba(16,24,40,0.06)",
        },
      },
    },
  },
});

export default appTheme;
